export default function foodTab() {
  const tab = document.querySelector(".is-food .section-food .food-tab");

  if (!tab) return;

  const triggers = tab.querySelectorAll(".food-tab__trigger");
  const contents = tab.querySelectorAll(".food-tab__content");

  triggers.forEach((trigger, index) => {
    trigger.addEventListener("click", () => {
      [...triggers, ...contents].forEach((el) => {
        el.classList.remove("is-active");
      });

      triggers[index].classList.add("is-active");
      contents[index].classList.add("is-active");
    });
  });
}
